import { fillOffset as e } from "./atoms-v21123.js";
function n(t) {
  const f = [0];
  return e(f, t.length - 1), f;
}
export {
  n as defaultOffset
};
